"use client";

import { c as _c } from "react/compiler-runtime";
import type { CreateWaveDatesConfig } from "@/types/waves.types";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import CreateWaveDatesApprove from "./CreateWaveDatesApprove";
import CreateWaveDatesRank from "./CreateWaveDatesRank";
import type { CREATE_WAVE_VALIDATION_ERROR } from "@/helpers/waves/create-wave.validation";
interface CreateWaveDatesProps {
  readonly waveType: ApiWaveType;
  readonly dates: CreateWaveDatesConfig;
  readonly errors: CREATE_WAVE_VALIDATION_ERROR[];
  readonly setDates: (dates: CreateWaveDatesConfig) => void;
}
export default function CreateWaveDates(t0) {
  const $ = _c(9);
  const {
    waveType,
    dates,
    errors,
    setDates
  } = t0;
  if (waveType === ApiWaveType.Approve) {
    let t1;
    if ($[0] !== dates || $[1] !== errors || $[2] !== setDates) {
      t1 = <CreateWaveDatesApprove dates={dates} errors={errors} setDates={setDates} />;
      $[0] = dates;
      $[1] = errors;
      $[2] = setDates;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  let t1;
  if ($[4] !== dates || $[5] !== errors || $[6] !== setDates || $[7] !== waveType) {
    t1 = <CreateWaveDatesRank waveType={waveType} dates={dates} errors={errors} setDates={setDates} />;
    $[4] = dates;
    $[5] = errors;
    $[6] = setDates;
    $[7] = waveType;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
}